import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 } from "uuid";
import { useLanguage } from "../../hooks/useLanguage";
import moment from "moment";

export const NotViewedExams = ({ exams, student, updateSelectedExam }) => {
	const [selectedExam,setSelectedExam] = useState()
	const {t} = useTranslation()
	useLanguage()
	return (
		<div className="card mt-3">
			<div className="card-header">
				{t('new_exam_result_publish',{name:student.name})}
			</div>
			<div className="card-body">
				<table className="table">
					<thead>
						<tr>
							<th>{t("course")}</th>
							<th>{t("exam")}</th>
							<th>{t("published_date")}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{exams?.map((exam) => (
							<tr key={v4()}>
								<th>{exam?.lecture?.course?.name}</th>
								<th>{exam?.exam_definition?.name}</th>
								<th>{moment(exam?.updated_at).format('DD-MM-YYYY')}</th>
								<th>
									<button
										className="btn btn-primary"
										onClick={() => {
											updateSelectedExam(exam)
											setSelectedExam(exam)
										}}
									>
										{selectedExam?.id === exam.id && <i className="fa fa-check me-2"></i>}{t("view")}
									</button>
								</th>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
